import React, { useState } from "react";
import { FaRegCopy } from "react-icons/fa";
import { FiCheck } from "react-icons/fi";

interface Props {
  value?: string;
  displayValue?: string;
  className?: string;
  textClassName?: string;
  showCopy?: boolean;
  truncate?: boolean;
}

const CopyableText: React.FC<Props> = ({
  value,
  displayValue,
  className = "",
  textClassName = "",
  showCopy = true,
  truncate = false,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!value || value === "—") return;

    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        className={`${truncate ? "truncate" : ""} ${textClassName}`}
      >
        {displayValue || value || "—"}
      </span>

      {showCopy && value && value !== "—" && (
        <button
          onClick={handleCopy}
          aria-label="Copy"
          className="shrink-0 text-gray-400 hover:text-white transition-colors"
        >
          {copied ? (
            <FiCheck size={14} className="text-green-400" />
          ) : (
            <FaRegCopy size={14} />
          )}
        </button>
      )}
    </div>
  );
};

export default React.memo(CopyableText);